import i18n from '../../utils/i18n';
import parse from 'html-react-parser';
// https://regexper.com/#-%3F%5Cd*%5C.%3F%5Cd*%5Cs%2B%5Ba-zA-Z%5D*
const NUMBERS_WITH_STRING_POSTFIX = /-?\d*\.?\d*\s+[a-zA-Z]*/;

function desc(a, b, orderBy, isAscending) {
	let itemA = a[orderBy];
	let itemB = b[orderBy];

	if (itemA === null) {
		return isAscending ? -1 : 1;
	}
	if (itemB === null) {
		return isAscending ? 1 : -1;
	}

	itemA = cleanValue(itemA);
	itemB = cleanValue(itemB);
	if (
		typeof itemA === 'string' &&
		typeof itemB === 'string' &&
		itemA.match(NUMBERS_WITH_STRING_POSTFIX) &&
		itemB.match(NUMBERS_WITH_STRING_POSTFIX)
	) {
		const aSubStrings = itemA.split(' ');
		const bSubStrings = itemB.split(' ');
		const aNumbPart = parseFloat(aSubStrings[0]);
		const bNumbPart = parseFloat(bSubStrings[0]);
		const aStrPart = aSubStrings[1];
		const bStrPart = bSubStrings[1];
		if (bNumbPart && aNumbPart) {
			return bNumbPart - aNumbPart;
		}

		return aStrPart.localeCompare(bStrPart);
	}

	if (typeof itemA === 'string' && typeof itemB === 'string') {
		return itemA.localeCompare(itemB);
	}

	return itemB - itemA || Number(itemB > itemA);
}

export function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy, false) : (a, b) => -desc(a, b, orderBy, true);
}

export function stableSort(array, cmp) {
	const stabilizedThis = array.map((el, index) => [el, index]);
	stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) {
			return order;
		}

		return a[1] - b[1];
	});
	return stabilizedThis.map(el => el[0]);
}

const cleanValue = v => {
	if (typeof v === 'string') {
		return v.replace(' *', '');
	}

	return v;
};

export const sumColumnValues = (columns, items) =>
	columns.map(column => items.map(item => parseFloat(item[column.key])).reduce((prev, curr) => prev + curr, 0));

export const getDescription = (desc, domain) => {
	return desc.split('?').length > 1
		? desc
				.split('?')
				.slice(1)
				.map(part => (isNaN(part) ? i18n.t(`components.bom.desc.${part}`) : part))
				.join(' ')
		: desc.includes('---')
		? domain.includes('.cn')
			? desc.split('---')[1]
			: desc.split('---')[0]
		: parse(desc);
};

/*
In case we wanted to skip empty (Cutsom component) values
export const sumColumnValues = (columns, items) =>
    columns.map(column =>
        items
            .map(item => item[column.key])
            .reduce((prev, curr) => prev + (curr ? parseFloat(curr) : 0), 0)
    );
*/
